export default {
  en: {
    footer: {
      provide: 'We provide the fastest and most efficient way to learn talking to air traffic control (ATC).',
      jointventure: 'Joint Venture project since 2024',
      madewith: 'Made with {heart} in',
      bug: 'Report a Bug',

      learning: 'Learning',
      about: 'About',
      contact: 'Contact',
      downloads: 'Downloads',
      gratitude: 'Gratitude',
      thankapp: 'Thank you for using our app. We are happy to help you learn ATC on {platform}.',
      androidapp: 'App for Android',
      links: {
        simulator:'Radio Simulator',
        flight:'Flight Scenarios',
        training:'Training Questions',
        lections:'Radio Lections',
        nato:'NATO Spelling Trainer',
        radio:'Radio Listening Trainer',

        knowledge: 'Knowledge',
        blog: 'Blog',
        features: 'Features',
        pricing: 'Pricing',
        faq: 'FAQ',
        tos: 'Terms',
      }
    },
  },
  de: {
    footer: {
      provide: 'Wir bieten die schnellste und effizienteste Möglichkeit, das Sprechen mit der Flugsicherung (ATC) zu erlernen.',
      jointventure: 'Joint Venture Projekt seit 2024',
      madewith: 'Erstellt mit {heart} in',
      bug: 'Fehler melden',

      learning: 'Lernen',
      about: 'Über uns',
      contact: 'Kontakt',
      downloads: 'Downloads',
      gratitude: 'Dankbarkeit',
      thankapp: 'Vielen Dank, dass Sie unsere App nutzen. Wir freuen uns, Ihnen beim Erlernen der ATC-Kommunikation auf {platform} zu helfen.',
      androidapp: 'App für Android',
      links: {
        simulator: 'Funk-Simulator',
        flight: 'Flugszenarien',
        training: 'Trainingsfragen',
        lections: 'Funklektionen',
        nato: 'NATO Buchstabiertrainer',
        radio: 'Funkhörtrainer',

        knowledge: 'Wissensdatenbank',
        blog: 'Blog',
        features: 'Funktionen',
        pricing: 'Preise',
        faq: 'FAQ',
        tos: 'AGB',
      }
    }
  },
  uk: {
    footer: {
      provide: 'Ми пропонуємо найшвидший і найефективніший спосіб навчитися спілкуватися з диспетчером повітряного руху (ATC).',
      jointventure: 'Спільний проект з 2024 року',
      madewith: 'Зроблено з {heart} в',
      bug: 'Повідомити про помилку',

      learning: 'Навчання',
      about: 'Про нас',
      contact: 'Контакт',
      downloads: 'Завантаження',
      gratitude: 'Подяка',
      thankapp: 'Дякуємо, що користуєтеся нашим додатком. Ми раді допомогти вам вивчити ATC на {platform}.',
      androidapp: 'Додаток для Android',
      links: {
        simulator: 'Радіо-симулятор',
        flight: 'Сценарії польотів',
        training: 'Питання для тренування',
        lections: 'Лекції з радіозв’язку',
        nato: 'Тренажер правопису НАТО',
        radio: 'Тренажер прослуховування радіо',

        knowledge: 'База знань',
        blog: 'Блог',
        features: 'Особливості',
        pricing: 'Ціни',
        faq: 'Питання та відповіді',
        tos: 'Умови',
      }
    }
  },
  es: {
    footer: {
      provide: 'Ofrecemos la forma más rápida y eficiente de aprender a hablar con el control de tráfico aéreo (ATC).',
      jointventure: 'Proyecto de empresa conjunta desde 2024',
      madewith: 'Hecho con {heart} en',
      bug: 'Reportar un error',

      learning: 'Aprendizaje',
      about: 'Acerca de',
      contact: 'Contacto',
      downloads: 'Descargas',
      gratitude: 'Gratitud',
      thankapp: 'Gracias por usar nuestra aplicación. Estamos felices de ayudarte a aprender ATC en {platform}.',
      androidapp: 'Aplicación para Android',
      links: {
        simulator: 'Simulador de radio',
        flight: 'Escenarios de vuelo',
        training: 'Preguntas de entrenamiento',
        lections: 'Lecciones de radio',
        nato: 'Entrenador de deletreo NATO',
        radio: 'Entrenador de escucha de radio',

        knowledge: 'Base de conocimiento',
        blog: 'Blog',
        features: 'Características',
        pricing: 'Precios',
        faq: 'Preguntas frecuentes',
        tos: 'Términos',
      }
    }
  }
}
